import { useIntl } from "react-intl";

import dynamic from "next/dynamic";

import SEO from "../../../SEO";
import Header from "../../../Header";
import Slider from "../../../Slider";
import Breadcrumbs from "../../../Breadcrumbs";
import Footer from "../../../Footer";

import Section from "../../../Section";
import Panel from "../../../Panel";
import DeclarationBox from "../../../DeclarationBox";
import DeclarationBoxItem from "../../../DeclarationBoxItem";
import Tabs from "../../../Tabs";
import AnotherCity from "../../../AnotherCity";
import BackButton from "../../../BackButton";
import DeclarationModal from "../../../DeclarationModal";

import Variables from "../../../../variables/variables.json";
import Steps from "../../../Steps";
import BackgroundSection from "../../../BackgroundSection";

export default function Poznan(props) {
	const intl = useIntl();

	let Miasto = props.miasto;
	let Podatek = props.podatek;

	// ODPADY KOMUNALNE
	const CityOdpadyKomunalneSection1PL = dynamic(() =>
		import(
			"../../../../content/" +
				Variables.miasta[Miasto].name.url +
				"/oplata-za-gospodarowanie-odpadami-komunalnymi/section-1_pl.mdx"
		),
	);

	const CityOdpadyKomunalneSection2PL = dynamic(() =>
		import(
			"../../../../content/" +
				Variables.miasta[Miasto].name.url +
				"/oplata-za-gospodarowanie-odpadami-komunalnymi/section-2_pl.mdx"
		),
	);

	const CityOdpadyKomunalneSection3PL = dynamic(() =>
		import(
			"../../../../content/" +
				Variables.miasta[Miasto].name.url +
				"/oplata-za-gospodarowanie-odpadami-komunalnymi/section-3_pl.mdx"
		),
	);

	const CityOdpadyKomunalneSection4PL = dynamic(() =>
		import(
			"../../../../content/" +
				Variables.miasta[Miasto].name.url +
				"/oplata-za-gospodarowanie-odpadami-komunalnymi/section-4_pl.mdx"
		),
	);

	return (
		<>
			{/* HEAD */}
			<SEO
				miasto={Miasto}
				podatek={Podatek}
				noindex={Variables.miasta[Miasto].test}
				nofollow={Variables.miasta[Miasto].test}
			/>

			{/* TOP */}
			<Header miasto={Miasto} />

			<Slider miasto={Miasto} podatek={Podatek} typeHero="slider" />

			<Breadcrumbs miasto={Miasto} layout="light" />

			{/* SECTION */}
			<Section mdx>
				<CityOdpadyKomunalneSection1PL />
			</Section>

			<Section id="wypelnij-deklaracje" title="sections.wypelnijdeklaracje.title">
				<DeclarationBox center>
					<DeclarationBoxItem miasto={Miasto} podatek={Podatek} noReadMore />
				</DeclarationBox>
			</Section>

			{/* SECTION */}
			<Section title="sections.jakzlozycdeklaracjeoplaty.title" mdx titleLeft>
				<CityOdpadyKomunalneSection2PL />
			</Section>

			{/* STEPS */}
			<Section>
				<Steps />
			</Section>

			{/* <!-- BACKGROUND --> */}
			<BackgroundSection
				miasto={Miasto}
				section="eko"
				textAlign="center"
				button="outlineWhite"
				fillCenter
				title
				white
				center
				transparent
				dek
			/>

			{/* SECTION */}
			<Section mdx>
				<CityOdpadyKomunalneSection3PL />
			</Section>

			<Section title={"miasta." + Miasto + ".sections.pozostalepodatki.title"}>
				<DeclarationBox miasto={Miasto} center>
					{Variables.miasta[Miasto].declarationBoxItem[Podatek].map((declarationBoxItem, index) => {
						return (
							<DeclarationBoxItem
								miasto={Miasto}
								podatek={declarationBoxItem.title}
								key={index}
								soon={declarationBoxItem.soon && true}
								noReadMore={declarationBoxItem.noReadMore && true}
							/>
						);
					})}
				</DeclarationBox>
				<DeclarationModal miasto={Miasto} />
			</Section>

			{/* SECTION */}
			<Section id="czytaj-wiecej" lightdark mdx>
				<CityOdpadyKomunalneSection4PL />
			</Section>

			{Variables.miasta[Miasto].documentsAvailable[Podatek] && (
				<Section
					lightdark
					smallTop
					title={"miasta." + Miasto + ".documents.podatki." + Podatek + ".title"}
				>
					<Tabs miasto={Miasto} podatek={Podatek} />
				</Section>
			)}

			<Section large>
				<Panel title="sections.anothercity.title" center>
					<AnotherCity />
				</Panel>
			</Section>

			<Section>
				<BackButton />
			</Section>

			{/* BOTTOM */}
			<Footer miasto={Miasto} />
		</>
	);
}
